var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 419,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    stroke: "#1B3242",
    strokeWidth: 5.807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M82.632 152.661v29.69h-59.38"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M142.011 182.351h-59.38v-29.69m29.69 29.69H52.942v29.689h59.379v-29.689zm-12.776 59.451H82.632V212.04h59.379m-118.758 0h59.379v29.762h-48.2M3 182.351h49.942v29.689h-29.69m131.97 0h-42.901v-29.689h20.616"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    stroke: "#1B3242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M376.332 398.524h-21.777v16.696h21.777v-16.696zm82.245 0H436.8v16.696h21.777v-16.696zm18.402-.035V20.293H336.153v378.196h140.826z",
    strokeWidth: 7.259
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M463.949 33.395H349.256v344.079h114.693V33.395z",
    strokeWidth: 7.259
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M463.949 63.375h-20.325v80.938h20.325V63.375zM362.165 242.849v19.236h80.938v-19.236h-80.938zm10.619-19.276v19.237h80.939v-19.237h-80.939z",
    strokeWidth: 7.259
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M362.64 207.658V223.7h80.938v-16.042H362.64zm80.984-124.176h20.325m-20.326-14.155h-17.276v74.986h17.276V69.327zm-17.276 18.584h17.276m-18.18-5.631l-14.082-8.13-35.315 61.166 14.081 8.13 35.316-61.165zm-22.833 7.01l14.082 8.13m-22.503 126.235v19.164m-13.356-35.207v15.898m2.105 19.308v19.237m81.011-114.185H349.256v10.743h114.693V147.87zm0 114.185H349.256v10.888h114.693v-10.888z",
    strokeWidth: 7.259
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M463.949 267.499H349.256v109.974h114.693V267.499z",
    strokeWidth: 7.259
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M438.034 298.495v47.982",
    strokeWidth: 7.985
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.628 415.221H485m-63.879 0h32.665m-354.459 0h307.421m-365.42 0h41.304",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.618 61.706h-66.42c-17.64 0-31.94 14.3-31.94 31.94v27.512h18.874V93.646c0-7.187 5.879-13.067 13.066-13.067h66.42c7.187 0 13.066 5.88 13.066 13.067v27.512h18.874V93.646c0-17.64-14.3-31.94-31.94-31.94z",
    fill: "#005581"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M203.785 96.332h-19.382v9.437h19.382v-9.437zm110.773 0h-19.382v9.437h19.382v-9.437z",
    fill: "#216F97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M282.618 61.706h-66.42c-17.64 0-31.94 14.3-31.94 31.94v6.751c0-17.64 14.3-31.94 31.94-31.94h66.42c17.64 0 31.94 14.3 31.94 31.94v-6.751c0-17.64-14.3-31.94-31.94-31.94z",
    fill: "#F52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.618 61.706h-66.42c-17.64 0-31.94 14.3-31.94 31.94v27.512h18.874V93.646c0-7.187 5.879-13.067 13.066-13.067h66.42c7.187 0 13.066 5.88 13.066 13.067v27.512h18.874V93.646c0-17.64-14.3-31.94-31.94-31.94z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.012 381.031h-18.438c-14.518 0-26.641-11.252-27.585-25.697-2.613-39.78 1.597-70.848 10.308-94.876 4.719-12.994 23.229-12.994 27.948 0 10.525 28.964 14.445 68.163 7.767 120.573z",
    fill: "#005581"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.696 260.459c-3.702-10.308-16.115-12.413-23.446-6.388l2.105 84.204c.29 11.615-4.936 22.068-13.284 28.891 4.791 8.348 13.792 13.938 24.027 13.938h18.438c6.606-52.483 2.686-91.682-7.84-120.645z",
    fill: "#005581"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.012 381.031h-18.438c-14.518 0-26.641-11.252-27.585-25.697-2.613-39.78 1.597-70.848 10.308-94.876 4.719-12.994 23.229-12.994 27.948 0 10.525 28.964 14.445 68.163 7.767 120.573z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.804 376.022h18.438c14.518 0 26.641-11.252 27.585-25.697 2.613-39.78-1.597-70.848-10.308-94.876-4.719-12.993-23.229-12.993-27.948 0-10.525 28.964-14.372 68.163-7.767 120.573z",
    fill: "#005581"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M375.534 332.395l2.032-83.406c-7.331-6.025-19.744-3.92-23.446 6.388-10.526 29.036-14.373 68.234-7.768 120.645h18.438c10.453 0 19.672-5.808 24.318-14.518-8.493-6.824-13.865-17.349-13.574-29.109z",
    fill: "#005581"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.804 376.022h18.438c14.518 0 26.641-11.252 27.585-25.697 2.613-39.78-1.597-70.848-10.308-94.876-4.719-12.993-23.229-12.993-27.948 0-10.525 28.964-14.372 68.163-7.767 120.573z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.713 415.221H170.176c-17.422 0-31.94-13.284-33.537-30.633a946.021 946.021 0 010-174.434c1.597-17.349 16.115-30.633 33.537-30.633h158.537c17.422 0 31.94 13.284 33.537 30.633a946.196 946.196 0 010 174.434c-1.67 17.349-16.115 30.633-33.537 30.633z",
    fill: "#216F97"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M362.25 374.498c-1.597 17.35-16.115 30.634-33.537 30.634H170.176c-17.422 0-31.94-13.284-33.537-30.634-2.541-27.366-3.847-54.733-3.993-82.172-.145 30.778 1.162 61.557 3.993 92.263 1.597 17.349 16.115 30.633 33.537 30.633h158.537c17.422 0 31.94-13.284 33.537-30.633 2.831-30.706 4.21-61.485 3.992-92.263-.145 27.367-1.452 54.806-3.992 82.172z",
    fill: "#005581"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.444 359.544c13.11 0 23.737-6.533 23.737-14.591s-10.627-14.591-23.737-14.591c-13.109 0-23.737 6.533-23.737 14.591s10.628 14.591 23.737 14.591z",
    stroke: "#216F97",
    strokeWidth: 5.807,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.545 300.238a1762.795 1762.795 0 0091.899 2.396c30.488 0 61.412-.799 91.9-2.396 9.364-.508 17.93-4.065 24.971-9.872-.291-26.06-1.597-52.047-3.993-78.035-1.597-17.349-16.115-30.633-33.536-30.633h-158.61c-17.422 0-31.94 13.284-33.537 30.633-2.396 25.988-3.775 51.975-3.993 78.035 6.969 5.807 15.535 9.364 24.899 9.872z",
    fill: "#216F97"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.176 405.132c-12.268 0-22.358-9.219-23.52-21.487-5.299-57.273-5.299-115.346 0-172.547 1.162-12.268 11.252-21.487 23.52-21.487h158.537c12.268 0 22.358 9.219 23.519 21.487 5.299 57.274 5.299 115.346 0 172.547-1.161 12.268-11.251 21.487-23.519 21.487H170.176z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.91 2.91"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M328.713 415.221H170.176c-17.422 0-31.94-13.284-33.537-30.633a946.021 946.021 0 010-174.434c1.597-17.349 16.115-30.633 33.537-30.633h158.537c17.422 0 31.94 13.284 33.537 30.633a946.196 946.196 0 010 174.434c-1.67 17.349-16.115 30.633-33.537 30.633z",
    stroke: "#013711",
    strokeWidth: 0.726,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M328.713 415.221H170.176c-17.422 0-31.94-13.284-33.537-30.633a946.021 946.021 0 010-174.434c1.597-17.349 16.115-30.633 33.537-30.633h158.537c17.422 0 31.94 13.284 33.537 30.633a946.196 946.196 0 010 174.434c-1.67 17.349-16.115 30.633-33.537 30.633z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M340.908 290.801a1789.54 1789.54 0 01-183 0c-21.051-1.089-37.094-20.979-36.876-45.224.29-33.319 1.524-65.984 3.702-98.069 1.524-22.576 18.075-40.578 38.11-41.595a1767.139 1767.139 0 01173.201 0c20.035.944 36.585 19.019 38.11 41.595 2.177 32.085 3.411 64.678 3.702 98.069.145 24.245-15.898 44.135-36.949 45.224z",
    fill: "#F52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M340.908 284.268a1789.54 1789.54 0 01-183 0c-20.253-1.016-35.86-19.454-36.876-42.465 0 1.524-.073 3.049-.073 4.5-.217 24.318 15.825 44.135 36.876 45.224a1789.559 1789.559 0 00183.001 0c21.051-1.089 37.093-20.978 36.875-45.224 0-1.524-.072-3.048-.072-4.5-.871 23.011-16.478 41.376-36.731 42.465z",
    fill: "#013711"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M125.823 251.602c.29-33.029 1.452-65.332 3.557-97.053 1.452-22.358 17.422-40.216 36.658-41.159a1679.051 1679.051 0 01166.667 0c19.237.943 35.207 18.801 36.659 41.159 2.105 31.794 3.266 64.097 3.557 97.053.072 8.493-1.815 16.478-5.227 23.229 6.315-8.058 10.09-18.874 10.017-30.706-.29-33.319-1.524-65.985-3.702-98.07-1.524-22.575-18.075-40.578-38.11-41.594a1767.118 1767.118 0 00-173.2 0c-20.035.944-36.586 19.019-38.11 41.594-2.178 32.085-3.412 64.678-3.702 98.07-.073 11.832 3.702 22.648 10.017 30.706-3.266-6.824-5.154-14.736-5.081-23.229z",
    fill: "#F52"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M273.109 202.894c-15.898.218-31.722.145-47.62 0-19.454-.29-35.206-15.244-35.206-32.883v-14.01c0-5.445 4.791-9.945 10.744-10.09 32.23-.726 64.532-.726 96.835 0 5.952.145 10.743 4.573 10.743 10.09v13.719c0 17.712-15.969 32.884-35.496 33.174z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M340.908 290.801a1789.54 1789.54 0 01-183 0c-21.051-1.089-37.094-20.979-36.876-45.224.29-33.319 1.524-65.984 3.702-98.069 1.524-22.576 18.075-40.578 38.11-41.595a1767.139 1767.139 0 01173.201 0c20.035.944 36.585 19.019 38.11 41.595 2.177 32.085 3.411 64.678 3.702 98.069.145 24.245-15.898 44.135-36.949 45.224z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M249.444 283.034c-30.197 0-60.83-.799-90.955-2.323-15.462-.798-27.44-16.188-27.294-35.061.29-32.811 1.524-65.622 3.702-97.489 1.161-17.349 13.719-31.432 28.528-32.157 28.528-1.38 57.564-2.106 86.092-2.106 28.6 0 57.564.726 86.092 2.106 14.808.725 27.367 14.881 28.528 32.157 2.178 31.867 3.412 64.678 3.702 97.489.145 18.873-11.832 34.263-27.294 35.061-30.343 1.524-60.903 2.323-91.101 2.323z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.91 2.91"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M273.109 197.087c-15.898.218-31.722.146-47.62 0-19.454-.29-35.206-15.244-35.206-32.883v-14.01c0-5.444 4.791-9.945 10.744-10.09 32.23-.726 64.532-.726 96.835 0 5.952.145 10.743 4.573 10.743 10.09v13.72c0 17.712-15.969 32.883-35.496 33.173z",
    fill: "#0BB68F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M273.109 184.675c-15.898.218-31.722.145-47.62 0-19.454-.291-35.206-15.244-35.206-32.884v-1.597 14.01c0 17.64 15.752 32.593 35.206 32.884 15.898.217 31.722.217 47.62 0 19.527-.291 35.496-15.462 35.496-33.174v-12.413c0 17.712-15.969 32.883-35.496 33.174z",
    fill: "#0BB68F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M297.789 140.104c-32.23-.726-64.532-.726-96.835 0-5.952.145-10.743 4.573-10.743 10.09v5.807c0-5.444 4.791-9.945 10.743-10.09 32.23-.726 64.533-.726 96.835 0 5.953.145 10.744 4.573 10.744 10.09v-5.807c.072-5.517-4.719-9.945-10.744-10.09z",
    fill: "#0BB68F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.109 197.087c-15.898.218-31.722.146-47.62 0-19.454-.29-35.206-15.244-35.206-32.883v-14.01c0-5.444 4.791-9.945 10.744-10.09 32.23-.726 64.532-.726 96.835 0 5.952.145 10.743 4.573 10.743 10.09v13.72c0 17.712-15.969 32.883-35.496 33.173z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M273.109 197.087c-15.898.218-31.722.146-47.62 0-19.454-.29-35.206-15.244-35.206-32.883v-14.01c0-5.444 4.791-9.945 10.744-10.09 32.23-.726 64.532-.726 96.835 0 5.952.145 10.743 4.573 10.743 10.09v13.72c0 17.712-15.969 32.883-35.496 33.173z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M203.64 284.994h-34.19a3.693 3.693 0 01-3.194-1.887l-10.598-19.745c-7.114-13.139-4.356-28.528 7.041-39.199l15.244-14.227c4.646-4.356 12.485-4.283 17.131 0l15.244 14.3c11.397 10.671 14.155 25.987 7.041 39.126l-10.525 19.745a3.696 3.696 0 01-3.194 1.887zm-32.013-7.259h29.835l9.582-17.785c5.517-10.09 3.267-21.994-5.662-30.342l-15.244-14.301c-1.815-1.669-5.372-1.742-7.186 0l-15.244 14.228c-8.929 8.348-11.179 20.325-5.663 30.415l9.582 17.785z",
    fill: "#013711"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M186.218 375.805c-7.549 0-13.72-6.17-13.72-13.719V245.07a3.594 3.594 0 013.63-3.63h20.18a3.594 3.594 0 013.63 3.63v117.016c0 7.549-6.171 13.719-13.72 13.719zm-6.46-127.106v113.387c0 3.557 2.903 6.46 6.46 6.46s6.461-2.903 6.461-6.46V248.699h-12.921z",
    fill: "#013711"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M171.047 276.283h31.068l9.655-18.8c5.735-11.034 3.484-24.028-5.807-33.102l-13.865-13.647c-2.904-2.903-8.13-2.903-11.034 0l-13.865 13.502c-9.219 9.074-11.469 22.213-5.807 33.247l9.655 18.8z",
    fill: "#216F97"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M169.45 276.284h34.19l10.598-19.745c6.315-11.542 3.775-25.189-6.388-34.698l-15.244-14.3c-3.194-3.049-8.929-3.049-12.123 0l-15.244 14.227c-10.162 9.51-12.63 23.229-6.387 34.844l10.598 19.672z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M174.894 269.025h-1.089l-.508-.944",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M170.902 263.581l-5.59-10.453c-4.718-8.638-2.758-18.874 4.936-26.06l15.244-14.228c.145-.145.508-.29 1.089-.29s1.016.218 1.161.29l15.244 14.3c7.768 7.26 9.655 17.204 4.937 25.988l-6.824 12.703",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.17 2.17"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.792 268.081l-.508.944h-1.088",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.767 269.025h-16.623",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.89 1.89"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M186.291 367.675c-5.59 0-10.09-4.501-10.09-10.09V240.569h20.18v117.016c.072 5.589-4.501 10.09-10.09 10.09z",
    fill: "#F9941C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M186.291 360.924c-5.59 0-10.09-4.501-10.09-10.09v6.751c0 5.589 4.5 10.09 10.09 10.09 5.589 0 10.09-4.501 10.09-10.09v-6.751c.072 5.589-4.501 10.09-10.09 10.09zm10.09-60.032h-20.18v16.332h20.18v-16.332z",
    fill: "#F9941C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M186.291 367.675c-5.59 0-10.09-4.501-10.09-10.09V240.569h20.18v117.016c.072 5.589-4.501 10.09-10.09 10.09z",
    stroke: "#013711",
    strokeWidth: 5.807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.201 315.773v-14.881h20.18v14.881h8.42v-19.236a4.058 4.058 0 00-4.065-4.065h-28.891a4.058 4.058 0 00-4.065 4.065v19.236h8.421z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M176.201 315.773v-14.881h20.18v14.881h8.42v-16.551a6.66 6.66 0 00-6.678-6.678h-23.592a6.66 6.66 0 00-6.678 6.678v16.551h8.348z",
    stroke: "#013711",
    strokeWidth: 5.807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M189.63 248.555l-6.678 6.678m6.678 0l-6.678-6.678",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 318.676a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 317.224a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 330.291a3.34 3.34 0 100-6.679 3.34 3.34 0 000 6.679z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 330.291a3.34 3.34 0 100-6.679 3.34 3.34 0 000 6.679z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 345.026a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 345.026a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 315.773a2.448 2.448 0 01-2.468-2.468v-21.342a2.448 2.448 0 012.468-2.468 2.448 2.448 0 012.468 2.468v21.342a2.448 2.448 0 01-2.468 2.468z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M186.218 315.773a2.448 2.448 0 01-2.468-2.468v-21.342a2.448 2.448 0 012.468-2.468 2.448 2.448 0 012.468 2.468v21.342a2.448 2.448 0 01-2.468 2.468z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M329.366 285.72h-34.19a3.694 3.694 0 01-3.194-1.888l-10.598-19.744c-7.114-13.139-4.355-28.528 7.041-39.199l15.244-14.228c4.646-4.355 12.486-4.283 17.132 0l15.244 14.301c11.396 10.67 14.155 25.987 7.041 39.126l-10.526 19.744a3.692 3.692 0 01-3.194 1.888zm-32.012-7.259h29.835l9.581-17.785c5.517-10.09 3.267-21.995-5.662-30.343l-15.244-14.3c-1.814-1.67-5.371-1.742-7.186 0l-15.244 14.228c-8.929 8.348-11.179 20.325-5.662 30.415l9.582 17.785z",
    fill: "#013711"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M296.701 276.283h31.068l9.655-18.8c5.734-11.034 3.484-24.028-5.807-33.102l-13.865-13.647c-2.904-2.903-8.13-2.903-11.034 0l-13.865 13.575c-9.219 9.074-11.469 22.212-5.807 33.246l9.655 18.728z",
    fill: "#216F97"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M295.176 276.284h34.19l10.598-19.745c6.316-11.542 3.775-25.189-6.387-34.698l-15.244-14.3c-3.194-3.049-8.929-3.049-12.123 0l-15.244 14.227c-10.163 9.51-12.631 23.229-6.388 34.844l10.598 19.672z",
    stroke: "#013711",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M300.62 269.025h-1.088l-.509-.944",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M296.628 263.581l-5.589-10.453c-4.719-8.638-2.759-18.874 4.936-26.06l15.244-14.228c.145-.145.508-.29 1.089-.29.58 0 1.016.218 1.161.29l15.244 14.3c7.767 7.26 9.654 17.204 4.936 25.988l-6.823 12.703",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.17 2.17"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M325.519 268.081l-.508.944h-1.089",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M319.494 269.025h-16.696",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.89 1.89"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M312.017 375.661c-7.549 0-13.719-6.171-13.719-13.72V244.925a3.594 3.594 0 013.629-3.629h20.18a3.594 3.594 0 013.63 3.629v117.016c0 7.549-6.17 13.72-13.72 13.72zm-6.46-127.106v113.386c0 3.557 2.903 6.461 6.46 6.461s6.461-2.904 6.461-6.461V248.555h-12.921z",
    fill: "#013711"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M312.017 367.675a10.069 10.069 0 01-10.09-10.09V240.569h20.18v117.016c0 5.589-4.5 10.09-10.09 10.09z",
    fill: "#F9941C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M312.017 360.706c-5.589 0-10.09-4.5-10.09-10.09v7.695c0 5.589 4.501 10.09 10.09 10.09 5.59 0 10.09-4.501 10.09-10.09v-7.695c0 5.517-4.5 10.09-10.09 10.09zm10.018-59.814h-20.18v16.332h20.18v-16.332z",
    fill: "#F9941C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M312.017 367.675a10.069 10.069 0 01-10.09-10.09V240.569h20.18v117.016c0 5.589-4.5 10.09-10.09 10.09z",
    stroke: "#013711",
    strokeWidth: 5.807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M301.927 315.773v-14.881h20.18v14.881h8.421v-19.236a4.058 4.058 0 00-4.065-4.065h-28.891a4.057 4.057 0 00-4.065 4.065v19.236h8.42z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M301.927 315.773v-14.881h20.18v14.881h8.421v-16.551a6.66 6.66 0 00-6.679-6.678h-23.591a6.66 6.66 0 00-6.679 6.678v16.551h8.348z",
    stroke: "#013711",
    strokeWidth: 5.807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M315.356 248.555l-6.678 6.678m6.678 0l-6.678-6.678",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 318.676a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 317.224a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 330.291a3.34 3.34 0 100-6.679 3.34 3.34 0 000 6.679z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 330.291a3.34 3.34 0 100-6.679 3.34 3.34 0 000 6.679z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 345.026a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 345.026a3.34 3.34 0 100-6.678 3.34 3.34 0 000 6.678z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 315.773a2.447 2.447 0 01-2.468-2.468v-21.342a2.447 2.447 0 012.468-2.468 2.448 2.448 0 012.468 2.468v21.342a2.448 2.448 0 01-2.468 2.468z",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 315.773a2.447 2.447 0 01-2.468-2.468v-21.342a2.447 2.447 0 012.468-2.468 2.448 2.448 0 012.468 2.468v21.342a2.448 2.448 0 01-2.468 2.468z",
    stroke: "#013711",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M303.524 175.092c2.541 3.194 7.477 3.194 10.018 0 1.524-1.887 1.814-4.5.798-6.751l-5.807-12.558-5.807 12.558c-1.017 2.178-.654 4.791.798 6.751z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M303.524 175.092c2.541 3.194 7.477 3.194 10.018 0 1.524-1.887 1.814-4.5.798-6.751l-5.807-12.558-5.807 12.558c-1.017 2.178-.654 4.791.798 6.751z",
    stroke: "#013711",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M190.211 159.703h116.725",
    stroke: "#013711",
    strokeWidth: 6.533,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "3.63 3.63"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M249.444 355.915c13.11 0 23.737-6.533 23.737-14.591s-10.627-14.591-23.737-14.591c-13.109 0-23.737 6.533-23.737 14.591s10.628 14.591 23.737 14.591z",
    fill: "#FCCA86"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M249.444 330.872c11.978 0 21.923 5.444 23.52 12.558a9.69 9.69 0 00.217-2.033c0-8.057-10.67-14.59-23.737-14.59-13.066 0-23.737 6.533-23.737 14.59 0 .726.073 1.379.218 2.033 1.597-7.114 11.469-12.558 23.519-12.558z",
    fill: "#FCCA86"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M249.444 349.381c-10.525 0-19.599-3.484-23.737-8.42v.363c0 8.057 10.671 14.591 23.737 14.591 13.067 0 23.737-6.534 23.737-14.591v-.363c-4.21 5.009-13.211 8.42-23.737 8.42z",
    fill: "#FCCA86"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M249.444 355.915c13.11 0 23.737-6.533 23.737-14.591s-10.627-14.591-23.737-14.591c-13.109 0-23.737 6.533-23.737 14.591s10.628 14.591 23.737 14.591z",
    stroke: "#013711",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M249.444 355.915c13.11 0 23.737-6.533 23.737-14.591s-10.627-14.591-23.737-14.591c-13.109 0-23.737 6.533-23.737 14.591s10.628 14.591 23.737 14.591z",
    stroke: "#013711",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M265.269 338.566c.871.944 1.379 1.888 1.379 2.759 0 2.032-2.686 4.646-7.259 6.388m-9.945-14.446c5.154 0 9.51 1.234 12.486 2.831",
    stroke: "#013711",
    strokeWidth: 2.178,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M103.102 96.258c25.538 0 46.24-20.702 46.24-46.24 0-25.537-20.702-46.24-46.24-46.24s-46.24 20.703-46.24 46.24c0 25.538 20.702 46.24 46.24 46.24z",
    stroke: "#1B3242",
    strokeWidth: 7.259,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M103.102 8.497v4.5m0 74.043v4.573m41.522-41.594h-4.501m-74.042 0h-4.5",
    stroke: "#1B3242",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M103.102 53.72a3.702 3.702 0 100-7.403 3.702 3.702 0 000 7.404z",
    fill: "#1B3242"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M103.102 50.019l19.962-24.681",
    stroke: "#1B3242",
    strokeWidth: 2.904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M90.544 37.679l12.558 12.34",
    stroke: "#1B3242",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingEducation);
export default __webpack_public_path__ + "static/media/pricing-education.598e6294c35fb3892ba969f7fa13b78c.svg";
export { ForwardRef as ReactComponent };